import { CommonProps, Heading } from '@modusign/design-system';
import { HTMLAttributes } from 'react';

interface TitleProps extends CommonProps, Omit<HTMLAttributes<HTMLHeadingElement>, 'color'> {}

function Title({ sx, ...props }: TitleProps) {
  return (
    <Heading
      {...props}
      as="h4"
      sx={{
        ...sx,
        bg: 'lightGray50',
        borderTopColor: 'lightGray300',
        borderTopStyle: 'solid',
        borderTopWidth: '1px',
        borderBottomColor: 'lightGray300',
        borderBottomStyle: 'solid',
        borderBottomWidth: '1px',
        color: 'textNeutralLight',
        fontSize: '13px',
        fontWeight: 'medium',
        px: '12px',
        py: '10px',
        textAlign: 'initial',
      }}
    />
  );
}

export default Title;
